import SeoRedux from './seo_redux';

export default SeoRedux;

// TODO: SEO App not to use path from redux but using react-router hooks
